const DURABILITY: Record<string, number> = {
    wooden_sword: 59,
    stone_sword: 131,
    iron_sword: 250,
    golden_sword: 32,
    diamond_sword: 1561,
    wooden_pickaxe: 59,
    stone_pickaxe: 131,
    iron_pickaxe: 250,
    golden_pickaxe: 32,
    diamond_pickaxe: 1561,
    wooden_axe: 59,
    stone_axe: 131,
    iron_axe: 250,
    golden_axe: 32,
    diamond_axe: 1561,
    wooden_shovel: 59,
    stone_shovel: 131,
    iron_shovel: 250,
    golden_shovel: 32,
    diamond_shovel: 1561,
    wooden_hoe: 59,
    stone_hoe: 131,
    iron_hoe: 250,
    golden_hoe: 32,
    diamond_hoe: 1561,
    leather_helmet: 55,
    chainmail_helmet: 165,
    iron_helmet: 165,
    golden_helmet: 77,
    diamond_helmet: 363,
    leather_chestplate: 80,
    chainmail_chestplate: 240,
    iron_chestplate: 240,
    golden_chestplate: 112,
    diamond_chestplate: 528,
    leather_leggings: 75,
    chainmail_leggings: 225,
    iron_leggings: 225,
    golden_leggings: 105,
    diamond_leggings: 495,
    leather_boots: 65,
    chainmail_boots: 195,
    iron_boots: 195,
    golden_boots: 91,
    diamond_boots: 429,
    bow: 384,
    fishing_rod: 64,
    flint_and_steel: 64,
    shears: 238,
    carrot_on_a_stick: 25,
};

export function maxDurability(name: string | undefined): number | undefined {
    if (!name) return undefined;
    return DURABILITY[name];
}
